<template>
    <div class="movie-box cinemas-details-wrapper">
         <!-- top返回 -->
      <MovieGoBack :text="text"></MovieGoBack>
      
      <div class="cinemas-details-content">

        <!-- 地址 -->
        <dl class="address-wrapper">
            <dt>星辉影城（和顺店）</dt>
            <dd>里水镇和顺大道8号万福城购物广场4楼</dd>
        </dl>


        <!-- 电影列表 -->
        <ul class="movie-horizontal-scroll-bar movies-all-wrapper">
            <li v-for="(item,ind) in moviesList" :key='ind' :class="{'checkedMovie': item.checked}" @click="checkedMovie(item)">
                <img v-lazy='item.img' />
            </li>
        </ul>

        <!-- 选中电影名称 -->
        <div>
            <h4 class="movie-name">{{checkedMovieInfo.title}}</h4>
            <p class="movie-director">
                <span>导演：{{checkedMovieInfo.director}}</span>
                <span>片长：{{checkedMovieInfo.duration}}分钟</span>
            </p>
        </div>

        <!-- tab -->
        <ul class="movie-horizontal-scroll-bar time-tab-wrapper">
            <li v-for="(item, ind) in sessionsList" :key="ind" 
                @click="switchDate(item)"
                :class="{'checkedTime':item.checked}">
                {{item.ShowDateLong || item.date}}
            </li>
        </ul>

        <!-- 场次列表 -->
        <ul class="sessions-wrapper">
            <router-link 
             v-for="(item, ind) in sessions" :key="ind"
             :to="{path:'/seatSelection'}">
            <li>
                <div class="time">{{item.time}}</div>
                <div class="address">
                    <div>{{item.type}}</div>
                    <div class="cinema">{{item.HallName}}</div>
                </div>
                <div class="price">
                    <div class="price-sale">{{item.price}}</div>
                    <div class="price-stand">{{item.StandPric}}</div>
                </div>
                <div class="movie-gradient page-absolute page-text-center buy-button">
                    购票
                </div>
            </li>
            </router-link>
        </ul>
      </div>

    </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";

export default {
    name:"CinemasDetails",
    components:{
        MovieGoBack
    },
    data:function(){
        return {
            text:'星辉影城（和顺店）',
            checkedMovieInfo:{}, //影片信息
            sessionsList:[], // 选择完影片后的日期场次
            sessions:[], // 选择日期之后的场次列表
            moviesList:[ // 全部
                {
                    id:0,
                    checked:true,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)1",
                            list:[
                                {
                                    time:'10:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)2",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                },{
                    id:1,
                    checked:false,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达阿凡达',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)3",
                            list:[
                                {
                                    time:'11:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'13:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'15:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'17:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'11:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'13:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'15:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'17:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)4",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.25周四',
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.26周五',
                            list:[
                                {
                                    time:'10:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }, {
                            date:'03.27周六',
                            list:[
                                {
                                    time:'10:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                },{
                    id:2,
                    checked:false,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡阿凡阿凡',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)1",
                            list:[
                                {
                                    time:'11:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'13:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'15:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'17:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)2",
                            list:[
                                {
                                    time:'10:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:32',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                             }
                        ]
                    }, {
                    id:3,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达3',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)5",
                            list:[
                                {
                                    time:'10:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)6",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                }, {
                    id:4,
                    checked:false,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)3",
                            list:[
                                {
                                    time:'10:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)4",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                }, {
                    id:5,
                    checked:false,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)1",
                            list:[
                                {
                                    time:'10:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)2",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                }, {
                    id:6,
                    checked:false,
                    img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
                    title:'阿凡达',
                    director:'詹姆斯·卡梅隆',
                    duration:150,
                    sessionsList:[
                        {
                            date:'03.23周二',
                            ShowDateLong: "今天(03.23周二)3",
                            list:[
                                {
                                    time:'10:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:30',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        },{
                            date:'03.24周三',
                            ShowDateLong: "明天(03.24周三)7",
                            list:[
                                {
                                    time:'10:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'12:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'14:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                },{
                                    time:'16:31',
                                    type:'原生/3D',
                                    price:85.8,
                                    HallName: "1号厅-IMAX激光",
                                    StandPric: 180
                                }
                            ]
                        }
                    ]
                }
                ]
            }

    },
    mounted:function(){
        // 请求数据之后先循环添加checked，默认第一条为true
        //

        let list = this.moviesList[0].sessionsList || [];
        if(list){
            list.forEach((item,ind) => {
                item.checked = false;
            })
            list[0].checked = true;
            this.sessionsList = list;//
            this.sessions = list[0].list;//
        }
        this.checkedMovieInfo = this.moviesList[0];//
    },
    methods:{
        checkedMovie:function(val){
            //选中电影
            this.moviesList.forEach((item,ind)=>{
                item.checked = false;
            })
            val.checked = true;
            this.checkedMovieInfo = {...val};
            //选中日期
            val.sessionsList.forEach((item, ind) => {
                item.checked = false;
            })
            val.sessionsList[0].checked = true;
            this.sessionsList = [...val.sessionsList];
            this.sessions = val.sessionsList[0].list;
        },
        switchDate:function(val){
            this.sessionsList.forEach((item, ind) => {
                item.checked = false;
            })
            val.checked = true;
            //切换日期
            this.sessions = [...val.list];
        }
    }
}
</script>

<style scoped>
.cinemas-details-wrapper{
    overflow:hidden;
}
.cinemas-details-content{
    padding:0 .3rem;
}
.address-wrapper{
    padding:.2rem 0;
    border-bottom:.01rem solid #ddd;
}
.address-wrapper dt{
    line-height: .4rem;
    font-size: .3rem;
}
.address-wrapper dd {
    color: #999;
    line-height: .4rem;
}
.movies-all-wrapper{
    padding:.5rem .15rem .2rem;
}
.movies-all-wrapper li{
    display:inline-block;
    margin-right:.3rem;
    opacity: .4;
}
@keyframes selectedAnimation{
    0%,100% {
        transform: scale(1,1);
    }
    100% {
        transform: scale(1.2,1.2);
    }
}
.checkedMovie {
    opacity: 1 !important;
    border:.01rem solid rgba(255, 16, 72, 1);
    position:relative;
    font-size:0;
    -webkit-transform-origin: center bottom;
    -webkit-animation-name: selectedAnimation;
    -webkit-animation-duration: .5s;
    -webkit-animation-iteration-count: 1;
    -webkit-animation-delay: 0s;
    -webkit-animation-fill-mode: forwards;
}
.checkedMovie::after{
    content:'▼';
    color:rgba(255, 16, 72, 1);
    position:absolute;
    bottom:-0.22rem;
    left:.5rem;
    font-size:.2rem;
    z-index: 1;
}
.movies-all-wrapper li img{
    width:1.2rem;
    height:1.5rem;
}
.movie-name{
    color: #666;
    font-size: .3rem;
    padding: .2rem 0;
}
.movie-director{
    color: #999;
}
.movie-director span:last-of-type{
    margin-left:.4rem;
}
.time-tab-wrapper{
    border-bottom:.01rem solid #ddd;
}
.time-tab-wrapper li{
    padding: .2rem .1rem;
    display:inline-block;
    margin-right:.2rem;
}
.time-tab-wrapper .checkedTime{
    color:rgba(255, 16, 72, 1);
    border-bottom:.02rem solid rgba(255, 16, 72, 1);
}
.sessions-wrapper{
    width:100%;
    overflow-x:hidden;
}
.sessions-wrapper li{
    box-sizing:border-box;
    padding:.2rem 1.7rem .2rem 0;
    border-bottom:.01rem solid #ddd;
    display:flex;
    justify-content: space-between;
    position:relative;
}
.sessions-wrapper .time{
    color:#333;
    font-size:.4rem;
}
.sessions-wrapper .address{
    margin:0 .2rem;
}
.address .cinema{
    margin:.1rem 0;
    color:#999;
}
.price-sale{
    color:rgba(255, 16, 72, 1);
    font-size:.36rem;
}
.price-stand{
    color:#666;
    text-decoration: line-through;
    font-style: italic;
}

.buy-button{
    top:50%;
    right:0;
    transform: translate(0,-50%);
    width:1.3rem;
    height:.5rem;
    line-height:.5rem;
    color:#fff;
    font-size:.2rem;
    border-radius:.5rem;
}

</style>